/**
 * Split a bilingual string ("English text 中文") into an English line and a
 * Chinese line for nicer two-line rendering. Falls back to the whole string
 * when no CJK characters are present.
 */
export function splitBilingual(cell: string): { en: string; zh: string } {
  const idx = cell.search(/[一-鿿]/);
  if (idx <= 0) return { en: cell, zh: '' };
  return { en: cell.slice(0, idx).trim(), zh: cell.slice(idx).trim() };
}
